import { TbCloudDownload } from "react-icons/tb";
import { isMobileSafari } from "src/libs/browser-lib";
import { Button } from "@memento/ui/Button";
import { cn } from "src/utils/cn";
import { forwardRef } from "react";

const downloadButtonStyles =
  "flex w-full items-center py-3 px-4 gap-3 text-gray-700 hover:text-gray-700 hover:bg-gray-50";

export const DownloadButton = forwardRef<
  HTMLButtonElement,
  {
    url: string;
    filename: string;
    className?: string;
  }
>(function DownloadButton({ url, filename, className }, _ref) {
  return isMobileSafari() ? (
    <Button
      type="button"
      className={cn(downloadButtonStyles, className)}
      onClick={() => window.open(url)}
    >
      <TbCloudDownload className="text-gray-400" size={20} />
      Download
    </Button>
  ) : (
    <a
      href={url}
      download={filename}
      className={cn(downloadButtonStyles, className)}
    >
      <TbCloudDownload className="text-gray-400" size={20} />
      Download
    </a>
  );
});
